module.exports = __webpack_public_path__ + "static/media/QR_PAK_TOTEM_DIGITAL.81cc3f56.png";